import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { TSendSmsApiResponseError } from "./SendSMSButton.types";

const StyledTableContainer = styled(TableContainer)`
  margin: 0.5rem 0;
  max-height: 18rem;
`;

const StyledTable = styled(Table)`
  .MuiTableCell-head {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    opacity: 0.75;
  }

  .MuiTableCell-body {
    padding: 0.25rem 0.5rem;
    font-size: 0.9375rem;
  }
`;

const StyledPhoneNumber = styled(Typography)`
  font-weight: 600;
  font-size: 0.9375rem;
`;

interface ISmsErrorsTableProps {
  errors: TSendSmsApiResponseError[];
}

const SmsErrorsTable: React.FC<ISmsErrorsTableProps> = ({ errors }) => {
  return (
    <StyledTableContainer>
      <StyledTable stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>
              <FormattedMessage
                id="SmsErrorsTable.Teléfono"
                defaultMessage="Teléfono"
              />
            </TableCell>
            <TableCell>
              <FormattedMessage
                id="SmsErrorsTable.Motivo"
                defaultMessage="Motivo"
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {errors.map((error, index) => (
            <TableRow key={`sms_err_${index}`}>
              <TableCell>
                <StyledPhoneNumber>{error.phone}</StyledPhoneNumber>
              </TableCell>
              <TableCell>
                {error.error_code === "sms_denied_before" ? (
                  <FormattedMessage
                    id="SmsErrorsTable.Este número está inactivo. Anteriormente ha habido errores enviando SMS a este número por lo que no se envía nada."
                    defaultMessage="Este número está inactivo. Anteriormente ha habido errores enviando SMS a este número por lo que no se envía nada."
                  />
                ) : (
                  error.error_detail
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </StyledTable>
    </StyledTableContainer>
  );
};

export default SmsErrorsTable;
